/* Ganga V2 · Tarjeta de producto (V2-01): aviso chico al agregar desde una tarjeta, sin abrir el cajón.
   - Producto simple: la tarjeta usa el product-form del tema (AJAX, secciones del cajón, contador, eventos).
     Acá solo se cambia el último paso, showCartDrawer, por el aviso. Lo marca data-gs-card en el form.
   - Con opciones: "Elegir" abre la vista rápida del tema (quick-view-modal con id terminado en -gs).
     Lo que se agrega desde esa vista rápida también avisa en vez de abrir el cajón.
   - Desde la ficha y desde el cajón no cambia nada: el cajón se abre como siempre.
   Lo carga snippets/gs-card-assets.liquid (data-envio-gratis en centavos). */
(function () {
  if (window.__gsCard) return;
  window.__gsCard = true;

  var script = document.getElementById('gs-card-js');
  var ENVIO = parseInt(script && script.getAttribute('data-envio-gratis'), 10) || 250000;
  var CART_URL = (script && script.getAttribute('data-cart-url')) || '/cart';
  var DURA = 3800;
  var CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/><path d="m7.5 12.3 3 3 6-6.3" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ALERTA = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 7v6M12 16.5v.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var CRUZ = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';

  var ultimoCarrito = null;
  var toast = null;
  var timer = null;

  function money(c) {
    try { return FoxTheme.Currency.formatMoney(c, FoxTheme.settings.moneyFormat); }
    catch (e) { return '$' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  }

  /* El carrito que acaba de publicar el tema (el aviso sale después, en showCartDrawer) */
  function escuchar() {
    if (!window.FoxTheme || !FoxTheme.pubsub) return;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (d) {
      if (d && d.cart && !d.cart.errors) ultimoCarrito = d.cart;
    });
  }
  escuchar();

  function cajon() { return document.querySelector('cart-drawer'); }

  function armar() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'gs-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    toast.addEventListener('click', function (e) {
      if (e.target.closest('.gs-toast__cerrar')) { cerrar(); return; }
      var ver = e.target.closest('.gs-toast__ver');
      if (!ver) return;
      var c = cajon();
      if (c && typeof c.show === 'function') {
        e.preventDefault();
        cerrar();
        c.show(ver);
      }
    });
    /* No se va mientras la persona lo está mirando con el mouse o el teclado */
    toast.addEventListener('mouseenter', function () { clearTimeout(timer); });
    toast.addEventListener('mouseleave', programar);
    toast.addEventListener('focusin', function () { clearTimeout(timer); });
    toast.addEventListener('focusout', programar);
    return toast;
  }

  function programar() { clearTimeout(timer); timer = setTimeout(cerrar, DURA); }
  function cerrar() { clearTimeout(timer); if (toast) toast.classList.remove('is-open'); }

  function lineaEnvio(cart) {
    if (!cart || typeof cart.total_price !== 'number') return '';
    var falta = ENVIO - cart.total_price;
    if (falta <= 0) return '<p class="gs-toast__envio">Tenés <strong>envío gratis</strong> en Montevideo</p>';
    return '<p class="gs-toast__envio">Te faltan <strong>' + money(falta) + '</strong> para el envío gratis en Montevideo</p>';
  }

  function mostrar(html, error) {
    var t = armar();
    t.classList.toggle('gs-toast--error', !!error);
    /* Se vacía y se llena en el cuadro siguiente para que el lector de pantalla lo anuncie */
    t.innerHTML = '';
    setTimeout(function () {
      t.innerHTML = html;
      t.classList.add('is-open');
      programar();
    }, 30);
  }

  function avisoAgregado(cart) {
    mostrar(
      '<div class="gs-toast__fila"><span class="gs-toast__ok">' + CHECK + 'Agregado</span>' +
      '<span class="gs-toast__sep" aria-hidden="true">·</span>' +
      '<a class="gs-toast__ver" href="' + CART_URL + '">Ver carrito</a>' +
      '<button type="button" class="gs-toast__cerrar" aria-label="Cerrar aviso">' + CRUZ + '</button></div>' +
      lineaEnvio(cart)
    );
  }

  function avisoError(msg) {
    var txt = document.createElement('span');
    txt.textContent = msg || 'No se pudo agregar. Probá de nuevo.';
    mostrar(
      '<div class="gs-toast__fila"><span class="gs-toast__ok">' + ALERTA + txt.innerHTML + '</span>' +
      '<button type="button" class="gs-toast__cerrar" aria-label="Cerrar aviso">' + CRUZ + '</button></div>',
      true
    );
  }

  function pedirCarrito(fn) {
    fetch(CART_URL + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(fn)
      .catch(function () { fn(null); });
  }

  /* "Elegir": si la vista rápida no llega a cargar (red lenta, error del servidor), a los 7 s se va a la ficha */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-gs-elegir]');
    if (!a) return;
    var qv = document.getElementById(a.getAttribute('aria-controls'));
    if (!qv || typeof qv.show !== 'function') return; /* sin la vista rápida, el link lleva a la ficha */
    setTimeout(function () {
      if (qv.open && qv.classList.contains('drawer--loading')) window.location.href = a.href;
    }, 7000);
  });

  /* Vista rápida con talle (plantillas, taloneras, disfraces): igual que la barra fija de la ficha (tanda 1),
     no se agrega el talle que el tema marca solo. Hasta que la persona toca un talle, el botón dice
     "Elegí tu talle" y al tocarlo marca el selector en vez de agregar. "Comprar ahora" (pago dinámico) queda
     apagado (gs-talle-pend, en gs-card.css) y al tocarlo también marca el selector: antes compraba el talle que
     marcaba el tema sin que la persona eligiera. Color y otras opciones: como el tema. */
  var TALLE = /^\s*(talla|talle|size)/i;
  function grupoTalle(qv) {
    var grupos = qv.querySelectorAll('variant-selects .product-form__input');
    for (var i = 0; i < grupos.length; i++) {
      var l = grupos[i].querySelector('[data-selected-swatch-value]');
      if (l && TALLE.test(l.getAttribute('data-selected-swatch-value') || '')) return grupos[i];
    }
    return null;
  }
  function pintarTalle(qv) {
    qv.classList.toggle('gs-talle-pend', !!qv.__gsTalle);
    var b = qv.querySelector('form[data-type="add-to-cart-form"] [type="submit"]');
    var txt = b && b.querySelector('.btn__text');
    if (!txt) return;
    var cta = b.querySelector('.gs-talle-cta');
    if (qv.__gsTalle && !cta) {
      cta = document.createElement('span');
      cta.className = 'btn__text gs-talle-cta';
      cta.textContent = 'Eleg\u00ed tu talle';
      txt.insertAdjacentElement('afterend', cta);
    }
    txt.style.display = qv.__gsTalle ? 'none' : '';
    if (cta) cta.style.display = qv.__gsTalle ? '' : 'none';
  }
  function marcarTalle(qv) {
    var g = grupoTalle(qv);
    if (!g) return;
    var lab = g.querySelector('.form__label');
    if (lab && !lab.querySelector('.gs-talle-aviso')) {
      var s = document.createElement('span');
      s.className = 'gs-talle-aviso';
      s.textContent = 'Eleg\u00ed tu talle';
      lab.appendChild(s);
    }
    g.classList.remove('gs-talle-marca');
    setTimeout(function () { g.classList.add('gs-talle-marca'); }, 30);
    try { g.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { g.scrollIntoView(); }
  }
  document.addEventListener('quick-view:loaded', function () {
    var abiertas = document.querySelectorAll('quick-view-modal[open]');
    for (var i = 0; i < abiertas.length; i++) {
      var qv = abiertas[i];
      if (!/-gs$/.test(qv.id || '')) continue;
      var g = grupoTalle(qv);
      var n = g ? (g.querySelectorAll('input[type="radio"]').length || ((g.querySelector('select') || {}).length || 0)) : 0;
      qv.__gsTalle = n > 1;
      if (!qv.__gsTalle || qv.__gsTalleInit) { pintarTalle(qv); continue; }
      qv.__gsTalleInit = true;
      var elegir = function (e) {
        var m = e.currentTarget, grupo = grupoTalle(m);
        if (!m.__gsTalle || !grupo || !e.target.closest) return;
        var campo = e.target.closest('input, label, select');
        if (campo && grupo.contains(campo)) {
          m.__gsTalle = false;
          var av = m.querySelector('.gs-talle-aviso');
          if (av) av.remove();
          setTimeout(function () { pintarTalle(m); }, 0);
        }
      };
      qv.addEventListener('click', elegir);
      qv.addEventListener('change', elegir);
      /* Fase de captura: corta el clic antes de que llegue al botón de Shopify */
      qv.addEventListener('click', function (e) {
        var m = e.currentTarget;
        if (!m.__gsTalle || !e.target.closest || !e.target.closest('.shopify-payment-button')) return;
        e.preventDefault();
        e.stopPropagation();
        marcarTalle(m);
      }, true);
      pintarTalle(qv);
    }
  });

  /* ¿El form viene de una tarjeta? 'tarjeta' (botón Agregar) / 'vista' (vista rápida de "Elegir") / '' */
  function origen(form) {
    if (form.hasAttribute('data-gs-card')) return 'tarjeta';
    var qv = form.closest('quick-view-modal');
    if (qv && /-gs$/.test(qv.id || '')) return 'vista';
    return '';
  }

  /* Antes de que el product-form del tema reciba el submit (fase de captura), se le cambia el paso final.
     El resto (pedido, errores, secciones del cajón, contador, eventos) sigue siendo el del tema. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || typeof form.showCartDrawer !== 'function') return;
    var tipo = origen(form);
    if (!tipo) return;
    if (tipo === 'vista') {
      var qvTalle = form.closest('quick-view-modal');
      if (qvTalle && qvTalle.__gsTalle && grupoTalle(qvTalle)) {
        e.preventDefault();
        e.stopPropagation();
        marcarTalle(qvTalle);
        return;
      }
    }
    if (form.__gsCard) return;
    form.__gsCard = tipo;

    form.showCartDrawer = function () {
      var boton = form.querySelector('[type="submit"]');
      if (tipo === 'vista') {
        var qv = form.closest('quick-view-modal');
        if (qv && qv.open) qv.hide();
      } else if (window.FoxTheme && FoxTheme.a11y) {
        /* Al repintar el cajón cerrado, el tema le pasa el foco: vuelve al botón de la tarjeta */
        FoxTheme.a11y.removeTrapFocus();
        if (boton) { try { boton.focus({ preventScroll: true }); } catch (err) {} }
      }
      var cart = ultimoCarrito;
      ultimoCarrito = null;
      if (cart) avisoAgregado(cart);
      else pedirCarrito(avisoAgregado);
    };

    if (tipo === 'tarjeta') {
      var errorTema = form.handleCartError;
      form.handleCartError = function (estado) {
        if (typeof errorTema === 'function') errorTema(estado);
        avisoError(estado && (estado.description || estado.message));
      };
    }
  }, true);
})();
